<div class="duration-filter-container">
  <span class="filter-label">Spieldauer:</span>

  @if (internalLoading) {
    <div class="loading-indicator">
      Lade...
    </div>
  }

  <!-- No options message -->
  @if (!internalLoading && (!availableIntervals || availableIntervals.length === 0)) {
    <div class="no-options-message">
      Keine Optionen
    </div>
  }

  @if (!internalLoading && availableIntervals && availableIntervals.length > 0) {
    <div class="filter-chips-container">
      <div
        class="filter-chip"
        [class.selected]="allSelected"
        (click)="toggleAll()">
        <span>Alle</span>
      </div>
      @for (filter of durationFilters; track trackByMinutes($index, filter)) {
        <div
          class="filter-chip"
          [class.selected]="filter.selected"
          (click)="toggleFilter(filter)">
          <span>{{ filter.minutes }} min</span>
        </div>
      }
    </div>
  }

  @if (shouldShowResetButton()) {
    <button
      class="clear-filters-btn"
      (click)="toggleAll()"
      title="Filter zurücksetzen">
      Zurücksetzen
    </button>
  }
</div>